import { render, staticRenderFns } from "./todayMedalDetail.vue?vue&type=template&id=40989528&scoped=true"
import script from "./todayMedalDetail.vue?vue&type=script&lang=js"
export * from "./todayMedalDetail.vue?vue&type=script&lang=js"
import style0 from "./todayMedalDetail.vue?vue&type=style&index=0&id=40989528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40989528",
  null
  
)

export default component.exports